import { render, staticRenderFns } from "./pcLoginComponent.vue?vue&type=template&id=d126d250&scoped=true"
import script from "./pcLoginComponent.vue?vue&type=script&lang=js"
export * from "./pcLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./pcLoginComponent.vue?vue&type=style&index=0&id=d126d250&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d126d250",
  null
  
)

export default component.exports